module.exports = __webpack_public_path__ + "static_1764244025768/img/openup_old.ac449d77.png";